import type { SpecChapterId, ParagraphIssueGroup } from '../types';

/**
 * 内容检查服务接口
 */
export const CheckContentService = Symbol.for('CheckContentService');

export interface CheckData {
    taskId: string;
    chapterType: SpecChapterId;
    regenerate?: boolean;
}

export interface CheckContentService {
    /**
     * 获取段落问题列表
     * @param options 检查数据
     * @param abortSignal 取消信号
     * @returns 段落问题列表
     */
    getParagraphIssueGroup(options: CheckData, abortSignal?: AbortSignal): Promise<ParagraphIssueGroup[]>;
}
